import theme from '@app/ui/theme'
import styled from 'styled-components'

export default styled.div`
  margin: 0px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  overflow-y: scroll;
`
